export enum RelationshipType {
    spouse,
    child,
    sibling,
    parent,
    friend,
}
